// extracted by mini-css-extract-plugin
export default {"alignment":"uxvwEs","title":"fgOEHN","dateLocation":"b6Z9By"};